import type React from 'react';
import { StyledContainer } from './Container.styles';

interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'full';
  slimPadding?: boolean;
}

const Container: React.FC<ContainerProps> = ({ children, className = '', size = 'md', slimPadding = false }) => {
  return (
    <StyledContainer size={size} slimPadding={slimPadding} className={className}>
      {children}
    </StyledContainer>
  );
};

export default Container;
